import { render, staticRenderFns } from "./PaySystem.vue?vue&type=template&id=10ecbe52&scoped=true&"
import script from "./PaySystem.vue?vue&type=script&lang=js&"
export * from "./PaySystem.vue?vue&type=script&lang=js&"
import style0 from "./PaySystem.vue?vue&type=style&index=0&id=10ecbe52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ecbe52",
  null
  
)

export default component.exports